import React from "react";
import "./Stay.css";
import bimg1 from "../../Images/Hall/conferenceHall.jpg";
import bimg2 from "../../Images/Rooms/finalImage.jpg";
function Stay() {
  return (
    <div className="stay-container">
      <p className="stay-title">
        Explore our carefully curated selection of rooms and suites, each
        designed to provide the ultimate in comfort and luxury
      </p>
      <div className="stay-upper">
        <div className="upper-title">
          <p className="upper-title-heading">Stay with us</p>
          <p className="upper-title-sub">
            Experience the comfort of our cozy bedrooms, and host your
            professional or casual events effortlessly in our versatile halls,
            designed for both parties and meeting
          </p>
          <p className="stay-upper-list">Party Halls</p>{" "}
          <hr style={{ marginTop: "-1rem" }} />
          <p className="stay-upper-list">Conference Halls</p>
          <hr style={{ marginTop: "-1rem" }} />
          <p className="stay-upper-list">Honeymoon Suites</p>
          <hr style={{ marginTop: "-1rem" }} />
          <p className="stay-upper-list">Elegant Single and Double Bedrooms</p>
          <hr style={{ marginTop: "-1rem" }} />
        </div>
        <img src={bimg1} alt="bimg1-new" className="bimg1" />
      </div>
      <div className="stay-lower">
        <img src={bimg2} alt="bimg2" className="bimg2" />
        <div className="lower-title">
          <p className="lower-title-heading">Economy Double Room</p>
          <p className="lower-title-discription">
            Our rooms are thoughtfully designed to provide maximum comfort,
            whether you're here for a relaxing solo getaway, a family vacation,
            or a romantic honeymoon. Each room is equipped with modern
            amenities, offering a perfect blend of style and convenience. For
            families, our spacious family suites and rooms provide ample space
            to relax. The longer you stay, the more you save, with special
            discounts for extended stays, ensuring a delightful and memorable
            experience.
          </p>
          <div className="dis">
            <div className="dis1">
              <hr className="myHr" id="first-hr" />
              <p className="discount1">
                <span className="discountPre">15%</span>{" "}
                <span className="dis-title"> Discount</span>
              </p>
              <p className="discount1-details">
                Stay 2 more{" "}
                <span className="discount1-details-sub">nights or more</span>
              </p>
            </div>
            <div className="dis2">
              <hr className="myHr" />
              <p className="discount1">
                <span className="discountPre">20%</span>{" "}
                <span className="discount-title"> Discount</span>
              </p>
              <p className="discount1-details">
                Stay 3 more{" "}
                <span className="discount1-details-sub">nights or more</span>
              </p>
            </div>
          </div>
          <br />
          <p className="last-container">
            Offer Available Until December 30th, 2024
          </p>
        </div>
      </div>
    </div>
  );
}

export default Stay;
